import { useState, useRef } from 'react';
import axios from 'axios';
import Footer from '../../component/footer';
import Header from '../../component/header';
import Toast from '../../component/Toast';
import BackgroundPaths from '../../component/BackgroundPaths';
import CountryCodeSelect from '../../component/CountryCodeSelect';
import { DEFAULT_COUNTRY } from '../../component/CountryCodeSelect/countries';
import { isValidMobile, exampleMobile } from '../../component/CountryCodeSelect/phone';

// E.164: a full international number has at most 15 digits
const MAX_PHONE_DIGITS = 15;

export default function Home() {
  const [formdata, setFormdata] = useState({
    username: '',
    mobile: '',
    email: '',
    usingTally: '',
  });
  const [country, setCountry] = useState(DEFAULT_COUNTRY);
  const [loading, setLoading] = useState(false);
  const [toasts, setToasts] = useState([]);
  const [shakeField, setShakeField] = useState(null);
  const idRef = useRef(0);

  const triggerShake = (field) => {
    setShakeField(field);
    setTimeout(() => setShakeField(null), 450);
  };

  const ApiUrl = process.env.REACT_APP_API_URL;

  const addToast = (message, type = 'info') => {
    const id = ++idRef.current;
    setToasts((prev) => [...prev, { id, message, type }]);
    setTimeout(() => removeToast(id), 4000);
  };

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormdata((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === 'mobile') {
    // Keep only digits, strip a pasted "+<country code>" and the local leading 0,
    // and cap so code + number never exceeds 15 digits
    let digits = value.replace(/\D/g, '');
    if (value.trim().startsWith('+') && digits.startsWith(country.dial)) {
      digits = digits.slice(country.dial.length);
    }
    digits = digits.replace(/^0+/, '').slice(0, MAX_PHONE_DIGITS - country.dial.length);
    setFormdata((prev) => ({ ...prev, mobile: digits }));
    return;
  }

  setFormdata((prev) => ({ ...prev, [name]: value }));
};

// const isValidTzMobile = (num) => /^[67]\d{8}$/.test(num);

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formdata.username.trim()) {
    triggerShake('username');
    return addToast('Please enter your name', 'error');
  }

  // if (!formdata.mobile.trim()) {
  //   triggerShake('mobile');
  //   return addToast('Please enter your mobile number', 'error');
  // }

if (!formdata.mobile.trim()) {
  triggerShake('mobile');
  return addToast('Please enter your mobile number', 'error');
}

// Country-wise check: right length + valid mobile prefix for the selected country
if (!isValidMobile(country, formdata.mobile)) {
  triggerShake('mobile');
  const example = exampleMobile(country);
  return addToast(
    `Enter a valid ${country.name} mobile number${example ? ` (e.g. ${example})` : ''}`,
    'error'
  );
}

// if (!isValidTzMobile(formdata.mobile)) {
//   triggerShake('mobile');
//   return addToast('Enter a valid Tanzania mobile number (e.g. 712345678)', 'error');
// }

if (!formdata.usingTally) {
  triggerShake('usingTally');
  return addToast('Please select whether you are using Tally', 'error');
}
  try {
    setLoading(true);
    // mobile = country code + number, e.g. "255712345678" (WhatsApp needs the full number)
    const payload = { ...formdata, mobile: `${country.dial}${formdata.mobile}` };
    const response = await axios.post(`${ApiUrl}send`, payload);

    console.log('Api response', response.data);

    // addToast(
    //   'Thank you for contacting us! We’ll send the document to your mobile number shortly.',
    //   'success'
    // );

addToast(
  'We are sharing the upcoming features of Tally on WhatsApp.\nThank you so much for your support.\nTeam Global',
  'success'
);

    setFormdata({
      username: '',
      mobile: '',
      email: '',
      usingTally: '',
    });

    // Redirect after successful submission
    setTimeout(() => {
      window.location.href = 'https://www.tallyglobal.co.tz/tallyprime-now';
    }, 5000);

  } catch (err) {
    if (err.response && err.response.data) {
      addToast(err.response.data.message || 'Something went wrong!', 'error');
    } else {
      addToast('Something went wrong!', 'error');
    }
  } finally {
    setLoading(false);
  }
};

  return (
    <div className='mainhomepage'>
      <Header/>
      <Toast toasts={toasts} removeToast={removeToast} />
      <div className='whatsapp-main'>
        <BackgroundPaths count={20} strokeColor="18, 118, 160" />
        <form onSubmit={handleSubmit} className="whatsappForm">

          {/* <div className="form-icon-3d">
            <div className="form-icon-3d-inner">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12c0 1.85.5 3.58 1.38 5.07L2 22l5.07-1.33A9.94 9.94 0 0 0 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2Z" fill="url(#waGradient)"/>
                <path d="M16.7 13.6c-.25-.13-1.47-.72-1.7-.81-.23-.08-.4-.13-.56.13-.17.25-.65.81-.8.98-.15.17-.3.19-.55.06-.25-.13-1.06-.39-2.02-1.24-.75-.66-1.25-1.48-1.4-1.73-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.44.13-.15.17-.25.25-.42.08-.17.04-.31-.02-.44-.06-.13-.56-1.34-.76-1.84-.2-.48-.4-.42-.56-.42h-.48c-.17 0-.44.06-.67.31-.23.25-.87.85-.87 2.07 0 1.22.89 2.4 1.01 2.57.13.17 1.75 2.67 4.24 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.1-.23-.17-.48-.29Z" fill="#fff"/>
                <defs>

                  <linearGradient id="waGradient" x1="2" y1="2" x2="22" y2="22" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#38E06A"/>
                    <stop offset="1" stopColor="#1CA84C"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div> */}
        
<h2 className="form-title">Learn About TallyPrime 7.1</h2>
<h6 className="form-subtitle">Fill In The Form</h6>

  <div className={`form-group${shakeField === 'username' ? ' shake-error' : ''}`}>
  <label htmlFor="username">Name</label>
  <div className="input-wrap">
    <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M12 12c2.7 0 4.9-2.2 4.9-4.9S14.7 2.2 12 2.2 7.1 4.4 7.1 7.1 9.3 12 12 12Zm0 2.5c-3.3 0-9.8 1.6-9.8 4.9V21h19.6v-1.6c0-3.3-6.5-4.9-9.8-4.9Z" fill="currentColor"/>
    </svg>
    <input
      id="username"
      type="text"
      name="username"
      placeholder="Enter your name"
      value={formdata.username}
      onChange={handleChange}
    />
  </div>
</div>



<div className={`form-group${shakeField === 'mobile' ? ' shake-error' : ''}`}>
  <label htmlFor="mobile">Mobile Number</label>
  <div className="input-wrap">
    <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.2.2 2.4.6 3.5.1.4 0 .8-.2 1.1L6.6 10.8Z" fill="currentColor"/>
    </svg>
    <CountryCodeSelect
      value={country}
      onChange={(c) => {
        setCountry(c);
        // Trim the number if the new code makes it too long
        setFormdata((prev) => ({ ...prev, mobile: prev.mobile.slice(0, MAX_PHONE_DIGITS - c.dial.length) }));
      }}
    />
    <input
      id="mobile"
      type="tel"
      inputMode="numeric"
      name="mobile"
      placeholder={exampleMobile(country) || 'Mobile number'}
      maxLength={MAX_PHONE_DIGITS - country.dial.length}
      style={{ paddingLeft: 112 + country.dial.length * 9 }}
      value={formdata.mobile}
      onChange={handleChange}
    />
  </div>
</div>


<div className="form-group">
  <label htmlFor="email">Email</label>
  <div className="input-wrap">
    <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Zm0 2v.01L12 12l8-5.99V6H4Zm0 12h16V8.24l-8 6-8-6V18Z" fill="currentColor"/>
    </svg>
    <input
      id="email"
      type="email"
      name="email"
      placeholder="Enter email address"
      value={formdata.email}
      onChange={handleChange}
    />
  </div>
</div>



<div className={`form-group${shakeField === 'usingTally' ? ' shake-error' : ''}`}>
  <label>Are you using Tally?</label>
  <div className="radio-group">
    <label className="radio-option">
      <input
        type="radio"
        name="usingTally"
        value="yes"
        checked={formdata.usingTally === 'yes'}
        onChange={handleChange}
      />
      <span>Yes</span>
    </label>
    <label className="radio-option">
      <input
        type="radio"
        name="usingTally"
        value="no"
        checked={formdata.usingTally === 'no'}
        onChange={handleChange}
      />
      <span>No</span>
    </label>
  </div>
</div>

          <button type="submit" disabled={loading}>
            {loading ? (
              <span className="btn-loading">
                <span className="spinner"></span> Sending...
              </span>
            ) : (
              <span className="btn-loading">
               Submit
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            )}
          </button>

        </form>
      </div>
      <Footer/>
      <img src='../images/bottommark.svg' alt='bottomimage' className='bottomimage'/>
    </div>
  );
}